/* Botaverra - decompte anime des chiffres cles (section bv-chiffres).

   LE CHIFFRE FINAL EST DEJA DANS LE HTML. Le script ne fait que le remplacer
   temporairement par sa valeur de depart. Sans JavaScript, ou si ce fichier ne
   se charge pas, la section affiche donc les bons chiffres - elle ne bouge
   simplement pas. Ne jamais inverser ce sens : ecrire 0 dans le gabarit et
   compter jusqu'a la vraie valeur rendrait la page fausse pour tous ceux qui
   n'executent pas le script.

   ON NE TOUCHE QU'AU PREMIER NOEUD TEXTE. Le balisage est
   `<span class="bvn__n">−90<i class="bvn__u">%</i></span>` : l'unite est un
   element a part. Ecrire dans `textContent` l'effacerait ; on ecrit donc dans
   `span.firstChild.nodeValue`.

   LE SIGNE EST CONSERVE TEL QUEL. "−90" utilise le vrai signe moins U+2212 et
   non le trait d'union : on l'isole en prefixe et on le recolle, plutot que de
   passer par parseFloat qui le perdrait. Meme chose pour la virgule decimale -
   "0,3" s'anime et se reaffiche avec une virgule, pas un point.

   PAS D'IntersectionObserver. Mesure du 2026-08-22 : il ne se declenche pas
   dans tous les contextes, et le decompte restait alors fige. On lit la
   position toutes les 200 ms, et l'intervalle s'arrete des que la section est
   passee. C'est aussi la seule methode sure ici : la page defile dans
   `.page-wrapper` et non dans la fenetre, donc les evenements `scroll` de
   `window` ne partent pas.

   MOUVEMENT REDUIT : on ne touche a rien, les chiffres restent affiches. */
(function () {
  var REDUIT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function aLEcran(el) {
    var r = el.getBoundingClientRect();
    var haut = Math.max(r.top, 0);
    var bas = Math.min(r.bottom, window.innerHeight);
    return r.height > 0 && (bas - haut) / r.height > 0.25;
  }

  function formater(v, dec, sep) {
    var t = v.toFixed(dec);
    return sep === ',' ? t.replace('.', ',') : t;
  }

  function preparer(span) {
    var noeud = span.firstChild;
    if (!noeud || noeud.nodeType !== 3) return null;

    var brut = noeud.nodeValue.trim();
    /* Prefixe non numerique (le signe moins), le nombre, puis un eventuel
       suffixe non numerique reste dans le meme noeud texte. */
    var m = brut.match(/^(\D*?)(\d+(?:[.,]\d+)?)(\D*)$/);
    if (!m) return null;

    var chiffres = m[2];
    var virgule = chiffres.indexOf(',') !== -1;
    var point = chiffres.indexOf('.') !== -1;
    var sep = virgule ? ',' : (point ? '.' : '');
    var dec = sep ? chiffres.split(sep)[1].length : 0;
    var cible = parseFloat(chiffres.replace(',', '.'));

    /* Un zero ne s'anime pas : compter de 0 a 0 ne montre rien. On le laisse
       tel quel plutot que d'inventer une valeur de depart. */
    if (!(cible > 0)) return null;

    return {
      noeud: noeud,
      prefixe: m[1],
      suffixe: m[3],
      cible: cible,
      dec: dec,
      sep: sep,
      ecrire: function (v) {
        this.noeud.nodeValue = this.prefixe + formater(v, this.dec, this.sep) + this.suffixe;
      }
    };
  }

  function init(section) {
    if (REDUIT) return;
    if (section.dataset.bvnPret === 'oui') return;
    section.dataset.bvnPret = 'oui';

    var duree = parseInt(section.getAttribute('data-bvn-anim'), 10);
    if (!duree) return;

    var cases = [];
    section.querySelectorAll('.bvn__n').forEach(function (span) {
      var c = preparer(span);
      if (c) cases.push(c);
    });
    if (!cases.length) return;

    /* Valeur de depart posee tout de suite : si on attendait la visibilite,
       le visiteur verrait le chiffre final passer a 0 sous ses yeux. */
    cases.forEach(function (c) { c.ecrire(0); });

    var lance = false;

    function animer() {
      var debut = null;
      function pas(t) {
        if (debut === null) debut = t;
        var p = Math.min((t - debut) / duree, 1);
        /* easeOutCubic : le decompte demarre vite et se pose doucement sur sa
           valeur, au lieu de s'arreter net. */
        var e = 1 - Math.pow(1 - p, 3);
        cases.forEach(function (c) { c.ecrire(c.cible * e); });
        if (p < 1) {
          window.requestAnimationFrame(pas);
        } else {
          cases.forEach(function (c) { c.ecrire(c.cible); });
        }
      }
      window.requestAnimationFrame(pas);
    }

    var minuteur = window.setInterval(function () {
      if (lance) return;
      if (aLEcran(section)) {
        lance = true;
        window.clearInterval(minuteur);
        animer();
      }
    }, 200);

    /* Cas de la section deja a l'ecran au chargement : on ne fait pas attendre
       200 ms de plus. */
    if (aLEcran(section)) {
      lance = true;
      window.clearInterval(minuteur);
      animer();
    }
  }

  function tout() {
    document.querySelectorAll('[data-bvn-anim]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }

  /* Dans l'editeur, une section rechargee revient avec ses chiffres finaux. */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-bvn-anim]').forEach(function (s) {
      s.dataset.bvnPret = '';
    });
    tout();
  });
})();
